export const herbBatches = {
  "ASH001": {
    id: "ASH001",
    herbName: "Ashwagandha",
    botanicalName: "Withania somnifera",
    farmer: {
      name: "Rajesh Kumar",
      location: "Madhya Pradesh, India",
      gps: {
        latitude: 23.2599,
        longitude: 77.4126
      }
    },
    harvestDate: "2024-03-15",
    processing: [
      {
        step: "Harvesting",
        date: "2024-03-15",
        description: "Roots harvested at optimal maturity"
      },
      {
        step: "Cleaning",
        date: "2024-03-16",
        description: "Roots cleaned and sorted"
      },
      {
        step: "Drying",
        date: "2024-03-17",
        description: "Sun-dried for 7 days at controlled temperature"
      },
      {
        step: "Grinding",
        date: "2024-03-24",
        description: "Ground to fine powder using traditional methods"
      }
    ],
    labTests: {
      moisture: "8.5%",
      pesticide: "Not Detected",
      heavyMetals: "Within Limits",
      microbiology: "Passed",
      withanolides: "2.8%",
      testDate: "2024-03-25",
      labName: "Ayurveda Quality Labs"
    },
    sustainability: {
      organic: true,
      fairTrade: true,
      carbonNeutral: false,
      waterConservation: true,
      soilHealth: "Excellent"
    },
    blockchain: {
      hash: "0x1a2b3c4d5e6f7g8h9i0j",
      timestamp: "2024-03-25T10:30:00Z",
      verified: true
    }
  },
  "TUL002": {
    id: "TUL002",
    herbName: "Turmeric",
    botanicalName: "Curcuma longa",
    farmer: {
      name: "Priya Sharma",
      location: "Kerala, India",
      gps: {
        latitude: 10.8505,
        longitude: 76.2711
      }
    },
    harvestDate: "2024-02-20",
    processing: [
      {
        step: "Harvesting",
        date: "2024-02-20",
        description: "Rhizomes harvested after 8 months"
      },
      {
        step: "Boiling",
        date: "2024-02-21",
        description: "Boiled for 45 minutes to enhance color"
      },
      {
        step: "Drying",
        date: "2024-02-22",
        description: "Solar dried for 10 days"
      },
      {
        step: "Grinding",
        date: "2024-03-04",
        description: "Ground to fine powder"
      }
    ],
    labTests: {
      moisture: "6.2%",
      pesticide: "Not Detected",
      heavyMetals: "Within Limits",
      microbiology: "Passed",
      curcumin: "6.5%",
      testDate: "2024-03-05",
      labName: "Spice Quality Institute"
    },
    sustainability: {
      organic: true,
      fairTrade: true,
      carbonNeutral: true,
      waterConservation: true,
      soilHealth: "Good"
    },
    blockchain: {
      hash: "0x9z8y7x6w5v4u3t2s1r0q",
      timestamp: "2024-03-05T14:20:00Z",
      verified: true
    }
  }
};
